import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, invalid, children, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'h-11 w-full rounded-lg border border-neutral-300 bg-white px-3 text-base text-yhelp-black',
        'focus-visible:border-yhelp-yellow focus-visible:outline-none',
        'dark:border-neutral-700 dark:bg-neutral-950 dark:text-neutral-100',
        invalid && 'border-priority-critico',
        className,
      )}
      {...rest}
    >
      {children}
    </select>
  );
});
